import React, { useEffect, useState } from 'react';
import './AepsCw.css'
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';
import { BASE_URL_APISERVICES , BASE_URL_AEPS } from '../../../utils/Constants';

export default function AepsCw() {
    const [bankList, setBankList] = useState([]);
    const [formData, setFormData] = useState({
        rrn: '',
        stanNo: '',
        txnId: '',
        aepstxnId: '',
        action: 'Credit',
        device: 'Mantra MFS 100',
        bankName: '',
        uId: '',
        authCode: '',
        deviceNo: '7587008',
        balance: '0.0',
        Agent_Id: '',
        Service: 'Cash Withdrawl',
        Amount: '',
        mobileNo: '',

    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [txnResponse, setTxnResponse] = useState(null);

    const initialFormState = {
        rrn: '',
        stanNo: '',
        txnId: '',
        aepstxnId: '',
        action: 'Credit',
        device: 'Mantra MFS 100',
        bankName: '',
        uId: '',
        authCode: '',
        deviceNo: '7587008',
        balance: '0.0',
        Agent_Id: '',
        Service: 'Cash Withdrawl',
        Amount: '',
        mobileNo: '',
    };

    const handleReset = () => {
        setIsModalOpen(false);
        if (modalData?.success) {
            setFormData(initialFormState);
            setErrors({});
        }
    };

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const response = await fetch(`${BASE_URL_AEPS}${API_ENDPOINTS.ALL_BANK}`);
                const result = await response.json();
                const banks = result.data || result.bankList || (Array.isArray(result) ? result : []);

                if (banks.length > 0) {
                    setBankList(banks);
                } else {
                    console.error("Bank list empty hai ya format galat hai");
                }
            } catch (error) {
                console.error("Bank List Fetch Error:", error);
            }
        };

        fetchBanks();
    }, []);

    const validateForm = () => {
        let newErrors = {};
        if (!formData.rrn.trim()) newErrors.rrn = "RRN is required.";
        if (!formData.stanNo.trim()) newErrors.stanNo = "Fingpay ID is required.";
        if (!formData.txnId.trim()) newErrors.txnId = "Transaction ID is required.";
        if (!formData.bankName) newErrors.bankName = "Please select a bank.";
        if (!(formData.uId)) {
            newErrors.uId = "Aadhaar Number is required.";
        }
        if (!formData.Agent_Id.trim()) newErrors.Agent_Id = "Agent ID is required.";

        const amt = parseFloat(formData.Amount);
        if (isNaN(amt)) {
            newErrors.Amount = "Please enter a valid amount.";
        }
        if (!/^[6-9]\d{9}$/.test(formData.mobileNo)) {
            newErrors.mobileNo = "Enter a valid 10-digit mobile number.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };




    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
    };

    const handleWithdraw = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);


        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");


            const raw = {
                ...formData,
                Amount: parseFloat(formData.Amount).toFixed(1).toString(),
                aepstxnId: formData.txnId,
                status: "0",
                txnStatus: "Success",

            };
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(raw),
                redirect: "follow",
            };

            const response = await fetch(`${BASE_URL_APISERVICES}${API_ENDPOINTS.AEPS_RESPONSE_UPDATE}`,
                requestOptions
            );
            const result = await response.json();
            setModalData({
                success: result.status === "0",
                message: result.description || (result.status === "0" ? "Transaction Successful" : "Transaction Failed"),
            });

            setIsModalOpen(true);

            if (result.status === "0") {
                setTxnResponse(result);
                setErrors({});
            } else {
                setErrors({ apiError: result.txnStatus || "Transaction Failed" });
            }
        } catch (err) {
            setModalData({
                success: false,
                message: "Network Error",
            });
            setIsModalOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const ErrorMsg = ({ msg }) => (
        msg ? <span className="reconx-error">{msg}</span> : null
    );


  return (
      <div className="reconx-container">
          <div className="reconx-card">
              <h2 className="reconx-title">AEPS Cash Withdrawal</h2>

              <form onSubmit={handleWithdraw} className="reconx-form">

                  <div className="reconx-group">
                      <label className="reconx-label">RRN</label>
                      <input name="rrn" value={formData.rrn} placeholder="Enter RRN"
                          className="reconx-input" onChange={handleChange} />
                      <ErrorMsg msg={errors.rrn} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Fingpay ID</label>
                      <input name="stanNo" value={formData.stanNo} placeholder="Enter Fingpay ID"
                          className="reconx-input" onChange={handleChange} />
                      <ErrorMsg msg={errors.stanNo} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Transaction ID</label>
                      <input name="txnId" value={formData.txnId} placeholder="Enter Transaction ID"
                          className="reconx-input" onChange={handleChange} />
                      <ErrorMsg msg={errors.txnId} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Select Bank</label>

                      <div className="reconx-select-wrap">
                          <select name="bankName" value={formData.bankName} onChange={handleChange}
                              className="reconx-select">
                              <option value="">-- Choose Bank --</option>
                              {bankList?.map((bank, i) => (
                                  <option key={i} value={bank.bankName || bank.name}>
                                      {bank.bankName || bank.name}
                                  </option>
                              ))}
                          </select>

                          <svg className="reconx-arrow" viewBox="0 0 20 20">
                              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                          </svg>
                      </div>

                      <ErrorMsg msg={errors.bankName} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Aadhaar No.</label>
                      <input name="uId" maxLength="12" value={formData.uId}
                          placeholder="Enter Aadhaar No." className="reconx-input"
                          onChange={handleChange} />
                      <ErrorMsg msg={errors.uId} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Agent ID</label>
                      <input name="Agent_Id" value={formData.Agent_Id}
                          placeholder="Enter Agent ID" className="reconx-input"
                          onChange={handleChange} />
                      <ErrorMsg msg={errors.Agent_Id} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Amount</label>
                      <input name="Amount" type="number" value={formData.Amount}
                          placeholder="Enter Amount" className="reconx-input"
                          onChange={handleChange} />
                      <ErrorMsg msg={errors.Amount} />
                  </div>

                  <div className="reconx-group">
                      <label className="reconx-label">Mobile No.</label>
                      <input name="mobileNo" maxLength="10" value={formData.mobileNo}
                          placeholder="Enter Mobile No." className="reconx-input"
                          onChange={handleChange} />
                      <ErrorMsg msg={errors.mobileNo} />
                  </div>

                  <button className="reconx-submit" disabled={loading}>
                      {loading ? "Processing..." : "Submit"}
                  </button>

              </form>
          </div>

          {isModalOpen && (
              <div className="reconx-modal-overlay">
                  <div className="reconx-modal-box">

                      <div className="reconx-modal-icon"
                          style={{
                              background: modalData?.success ? "#dcfce7" : "#fee2e2",
                              color: modalData?.success ? "#16a34a" : "#dc2626"
                          }}>
                          {modalData?.success ? "✓" : "✕"}
                      </div>

                      <h3 className="reconx-modal-status"
                          style={{ color: modalData?.success ? "#16a34a" : "#dc2626" }}>
                          {modalData?.success ? "SUCCESS" : "FAILED"}
                      </h3>

                      <div className="reconx-modal-info">
                          {!modalData?.success && <p className="reconx-api-label">API Error Message</p>}
                          <p>{modalData?.message}</p>
                      </div>

                      <button className="reconx-done" onClick={handleReset}>
                          Done
                      </button>

                  </div>
              </div>
          )}
      </div>
  )
}